<script setup lang="ts">
import type { HorizontalListProps } from '.';

defineProps<HorizontalListProps>();
</script>

<template>
	<div class="flex w-full flex-nowrap items-center">
		<div
			v-for="(item, index) in items"
			:key="`horizontal-list-item-${item.key}`"
			class="flex items-center"
		>
			<div
				class="flex w-full items-center justify-start gap-[6px] whitespace-nowrap md:gap-1"
			>
				<span class="text-sm font-normal leading-[150%] text-primary-light-3">
					{{ item.label }}
				</span>
				<span
					class="text-sm font-semibold leading-[150%] text-primary-light-2 md:text-primary"
				>
					{{ item.value }}
				</span>
			</div>

			<div
				v-if="index < items.length - 1"
				class="mx-2 size-1 shrink-0 rounded-none bg-beige"
			></div>
		</div>
	</div>
</template>
